/* eslint-disable camelcase */
import aes from 'crypto-js/aes';
import store from '../../store';
import readCookie from './readCookie';
import questions from '../../survey/questions';
import getParameterFromURL from './getParameterFromURL';
// import { hasFbpxlsValue } from './hasFbpxlsValue';

let geoSplitPromise = null;
const darkTheme = getParameterFromURL('darkTheme') === 'true';

export function ensureGeoSplitOnce() {
  if (geoSplitPromise) return geoSplitPromise;
  geoSplitPromise = (async () => {
    try {
      const res = await fetch('https://api.verv.com/v4/split/geo', { method: 'GET' });
      const data = await res.json();

      localStorage.setItem('country_code', data?.country_code);
    } catch (_) {
      // тихо пропускаем
    }
    return true;
  })();
  return geoSplitPromise;
}

function getLinkToPaymentPage() {
  const url = new URL(process.env.REACT_APP_LINK_TO_PAY);
  let stringParams = '';
  // get all parameters from source url
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = {};
  urlSearchParams.forEach((value, key) => {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      if (Array.isArray(params[key])) {
        params[key].push(value);
      } else {
        params[key] = [params[key], value];
      }
    } else {
      params[key] = value;
    }
  });

  // set some additional parameters
  params.source = 'paid-web-onboarding';

  // check necessary parameters
  const { forceLang } = store.getState().global;
  if (forceLang) {
    params.force_lang = forceLang;
  }

  // fbc
  if (!params.fbc) {
    const cookieFbc = readCookie('_fbc');
    const fbclidValue = params.fbclid;
    if (cookieFbc) {
      params.fbc = cookieFbc;
    } else if (fbclidValue) {
      const timeUnixNow = Date.now();
      params.fbc = `fb.1.${timeUnixNow}.${fbclidValue}`;
    }
  }

  // fbp
  if (!params.fbp) {
    const cookieFbp = readCookie('_fbp');
    if (cookieFbp) {
      params.fbp = cookieFbp;
    }
  }

  // utm_campaign
  if (!params.utm_campaign) {
    params.utm_campaign = 'paid-web-onboarding';
  }

  const customV2Age = questions.getAnswers({ questionName: 'customV2_age' });
  const startPageAge = questions.getAnswers({ questionName: 'start_page_age' });
  const age = questions.getAnswers({ questionName: 'age' });

  const resolvedAge = customV2Age || startPageAge || age;

  if (startPageAge) {
    const ageAnswer = Object.values(startPageAge)[0];

    if (ageAnswer?.a_value) {
      params.ageValue = ageAnswer.a_value;
    }
  }

  if (resolvedAge) {
    params.age = encodeURIComponent(JSON.stringify(resolvedAge));
  }

  const goal = questions.getAnswers({ questionName: 'goal' });
  if (goal) {
    params.goal = encodeURIComponent(JSON.stringify(goal));
  }

  const biting = questions.getAnswers({ questionName: 'biting' });
  if (biting) {
    params.biting = encodeURIComponent(JSON.stringify(biting));
  }

  const potty_training = questions.getAnswers({ questionName: 'potty_training' });
  if (potty_training) {
    params.potty_training = encodeURIComponent(JSON.stringify(potty_training));
  }

  const commands = questions.getAnswers({ questionName: 'commands' });
  if (commands) {
    params.commands = encodeURIComponent(JSON.stringify(commands));
  }

  const commandsPuppy = questions.getAnswers({ questionName: 'commands_puppy' });
  if (commands) {
    params.commands = encodeURIComponent(JSON.stringify(commandsPuppy));
  }

  const name = questions.getAnswers({ questionName: 'customV2_name' });
  if (name) {
    params.name = encodeURIComponent(JSON.stringify(name));
  }

  const mail = questions.getAnswers({ questionName: 'mail' });
  if (mail) {
    const emailValue = aes.encrypt(mail.value, '9213812384').toString();
    params.ev = emailValue;
  }

  const commandObj1 = questions.getAnswers({ questionName: 'customV2_command_1' });
  const commandObj2 = questions.getAnswers({ questionName: 'customV2_command_2' });
  const commandObj3 = questions.getAnswers({ questionName: 'customV2_command_3' });
  const commandObj4 = questions.getAnswers({ questionName: 'customV2_command_4' });

  let command1Value = [];
  if (commandObj1) {
    command1Value = Object.keys(commandObj1);
  }

  let command2Value = [];
  if (commandObj2) {
    command2Value = Object.keys(commandObj2);
  }

  let command3Value = [];
  if (commandObj3) {
    command3Value = Object.keys(commandObj3);
  }

  let command4Value = [];
  if (commandObj4) {
    command4Value = Object.keys(commandObj4);
  }

  if (Array.isArray(command1Value) && Array.isArray(command2Value) && Array.isArray(command3Value) && Array.isArray(command4Value)) {
    const combinedArray = [...command1Value, ...command2Value, ...command3Value, ...command4Value];
    stringParams += `&cn=${combinedArray.length}`;
  }

  const issuesObj1 = questions.getAnswers({ questionName: 'customV2_potty' });
  const issuesObj2 = questions.getAnswers({ questionName: 'customV2_issues' });
  const issuesObj3 = questions.getAnswers({ questionName: 'customV2_walking_issues' });
  const allIssues = [
    ...Object.keys(issuesObj1),
    ...Object.keys(issuesObj2),
    ...Object.keys(issuesObj3),
  ];
  const mapped = allIssues
    .map((issue) => {
      const pottyGroup = [
        'Pottying  without a stable schedule',
        'Potty accidents during the night',
        'Potty accidents when left alone at home',
      ];
      const barkingGroup = [
        'Barking',
        'Barking at other dogs',
        'Barking at peoplee',
      ];
      const bitingGroup = [
        'Biting',
        'Chewing or damaging furniture',
      ];

      if (pottyGroup.includes(issue)) {
        return 'Potty';
      }
      if (barkingGroup.includes(issue)) {
        return 'Barking';
      }
      if (bitingGroup.includes(issue)) {
        return 'Biting';
      }
      if (issue === 'Very anxious and sad when left alone') {
        return 'alone';
      }

      if (
        issue === 'Difficulties with crate training'
        || issue === 'Eating trash from the streets'
      ) {
        return null;
      }

      return issue;
    })
    .filter((issue) => issue != null)
    .filter((issue, idx, arr) => arr.indexOf(issue) === idx);

  const issuesList = encodeURIComponent(mapped.join(','));

  if (issuesList) {
    stringParams += `&issues=${issuesList}`;
  }

  const config = getParameterFromURL('config');
  const firebase = window.firebaseConfigData;
  const subscrUK = window.firebaseConfigData && window.firebaseConfigData.subscrUK === 'subscrUK_b';
  const subscrEU = window.firebaseConfigData && window.firebaseConfigData.subscrEU === 'subscrEU_b';
  const p10SubscrUS = window.firebaseConfigData && window.firebaseConfigData.p10_subscrUS === 'true';
  const customV2 = getParameterFromURL('config') === 'customV2';
  const customV53 = getParameterFromURL('config') === 'customV53';
  const customV54 = getParameterFromURL('config') === 'customV54';
  const everydoggyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const tariff = getParameterFromURL('tariff') || null;
  const mix = getParameterFromURL('mix') === 'true';
  const testPDF = window.firebaseConfigData && window.firebaseConfigData.customV2_pdf_19_29 === 'customV2_pdf_19_29_b';
  const testCheckout = window.firebaseConfigData && window.firebaseConfigData.customV2_checkout_personalOffer === 'customV2_checkout_personalOffer_b' ? 'B' : 'A';
  const p10testIntroPricesInDays = window.firebaseConfigData && window.firebaseConfigData.p10_intro_pricesInDays === 'p10_intro_pricesInDays_b';
  const p14testIntroPricesInDays = window.firebaseConfigData && window.firebaseConfigData.p14_intro_pricesInDays === 'p14_intro_pricesInDays_b';
  const p13testIntroPricesInDays = window.firebaseConfigData && window.firebaseConfigData.p13_intro_pricesInDays === 'p13_intro_pricesInDays_b';
  const p10CheckoutPlanInfo = window.firebaseConfigData && window.firebaseConfigData.p10_checkout_planInfo === 'p10_checkout_planInfo_b';
  const p14CheckoutPlanInfo = window.firebaseConfigData && window.firebaseConfigData.p14_checkout_planInfo === 'p14_checkout_planInfo_b';
  const p13CheckoutPlanInfo = window.firebaseConfigData && window.firebaseConfigData.p13_checkout_planInfo === 'p13_checkout_planInfo_b';
  const currencyInISO = window.firebaseConfigData && window.firebaseConfigData.currencyInISO === 'currencyInISO_b';
  const p13Paywall2blocks = window.firebaseConfigData && window.firebaseConfigData.p13_paywall_2blocks;
  const p13v1PaywallBeforeAfter = window.firebaseConfigData && window.firebaseConfigData.p13v1_paywall_beforeAfter;
  const p10PaymentPagewt = window.firebaseConfigData && window.firebaseConfigData.p10_paymentPage_wt === 'p10_paymentPage_wt_on';
  // const p13v1PaywallMoneyBack = window.firebaseConfigData && window.firebaseConfigData.p13v1_paywall_moneyBack === 'true';
  // const p13MixPaywallMoneyBack = window.firebaseConfigData && window.firebaseConfigData.p13_mix_paywall_moneyBack === 'true';
  const p13HighPrices = window.firebaseConfigData && window.firebaseConfigData.p13_highPrices === 'true';

  const p20v1ApplePayV3MainMethod = window.firebaseConfigData && window.firebaseConfigData.p20v1_applePay_v3_mainMethod === 'true';

  const p20v53LastDogTraining = window.firebaseConfigData && window.firebaseConfigData.p20v53_paywall_lastDogTraining === 'true';
  const p20v54LastDogTraining = window.firebaseConfigData && window.firebaseConfigData.p20v54_paywall_lastDogTraining === 'true';

  const p13MixP18 = window.firebaseConfigData && window.firebaseConfigData.p13_mix_p18 === 'true'; 
  // const p13_highPrices = window.firebaseConfigData && window.firebaseConfigData.p13_highPrices === 'true';
  // const firstScreenAB = localStorage.getItem('p10_firstScreens_zw') === 'B';
  // const firstScreenAB = customV2 && everydoggyV5 && !tariff;
  const firstScreenAB = false;
  const p13MixPaywallDiscountPercent = window.firebaseConfigData && window.firebaseConfigData.p13_mix_paywall_discountPercent === 'true';
  
  const isHardwareEnabled = window.firebaseConfigData && window.firebaseConfigData?.hardware === 'true';

  const isRedLabelDiscountEnabled = window.firebaseConfigData && window.firebaseConfigData?.p20v1_paywall_redLabelDiscount_noSpecial === 'true';
  
  if (subscrUK && tariff === 'v41') {
    stringParams += '&subscrUK=true';
  }

  if (subscrUK && tariff === 'v43') {
    stringParams += '&subscrUK=true';
  }

  if (subscrUK && tariff === 'v45') {
    stringParams += '&subscrUK=true';
  }

  if (subscrUK && tariff === 'v47') {
    stringParams += '&subscrUK=true';
  }

  if (subscrUK && tariff === 'v48') {
    stringParams += '&subscrUK=true';
  }

  if (subscrUK && tariff === 'v31' && mix) {
    stringParams += '&subscrUK=true';
  }

  if (subscrEU && tariff === 'v41') {
    stringParams += '&subscrEU=true';
  }

  if (subscrEU && tariff === 'v43') {
    stringParams += '&subscrEU=true';
  }

  if (subscrEU && tariff === 'v45') {
    stringParams += '&subscrEU=true';
  }

  if (subscrEU && tariff === 'v47') {
    stringParams += '&subscrEU=true';
  }

  if (subscrEU && tariff === 'v48') {
    stringParams += '&subscrEU=true';
  }

  if (customV2 && everydoggyV5 && !tariff && p10SubscrUS) {
    stringParams += '&p10SubscrUS=true';
  }

  const customV2Aage = firstScreenAB ? questions.getAnswers({ questionName: 'zw_age' }) : questions.getAnswers({ questionName: 'customV2_age' });

  if (customV2Aage) {
    const firstKey = Object.keys(customV2Aage)[0];
    const ageValue = customV2Aage[firstKey]?.value;

    const puppyAges = [
      '0-6 months',
      '0-2 months',
      '2-6 months',
      '6-11 months',
      '7-12 months',
    ];

    const isPuppy = puppyAges.includes(ageValue);

    stringParams += `&role=${isPuppy ? 'puppy' : 'adult'}`;
  }

  if (customV2 && !tariff) {
    if (testPDF) {
      stringParams += '&testPDF=B';
    } else {
      stringParams += '&testPDF=A';
    }
    if (testCheckout) {
      stringParams += `&personalOffer=${testCheckout}`;
    }
  }

  if (customV2 && everydoggyV5) {
    // if (testIntroPricesInDays) {
    //   finalEmail += '&pricesInDays=true';
    // }

    if (p10CheckoutPlanInfo && tariff !== 'v27' && tariff !== 'v29' && tariff !== 'v31') {
      stringParams += '&p10CheckoutPlanInfo=true';
    }

    if (p14CheckoutPlanInfo && tariff === 'v29') {
      stringParams += '&p14CheckoutPlanInfo=true';
    }

    if (p13CheckoutPlanInfo && tariff === 'v31') {
      stringParams += '&p13CheckoutPlanInfo=true';
    }

    if (p10testIntroPricesInDays && tariff !== 'v27' && tariff !== 'v29' && tariff !== 'v31') {
      stringParams += '&p10testIntroPricesInDays=true';
    }

    if (p14testIntroPricesInDays && tariff === 'v29') {
      stringParams += '&p14testIntroPricesInDays=true';
    }

    if (p13testIntroPricesInDays && tariff === 'v31') {
      stringParams += '&p13testIntroPricesInDays=true';
    }

    if (p10PaymentPagewt && !tariff) {
      stringParams += '&p10PaymentPagewt=true';
    }

    if (!tariff && firstScreenAB) {
      stringParams += '&fSW=true';
    }

    if ((p13Paywall2blocks !== 'false' && p13Paywall2blocks !== false) && tariff === 'v31') {
      stringParams += '&p13P2B=true';
    }

    if ((p13v1PaywallBeforeAfter !== 'false' && p13v1PaywallBeforeAfter !== false) && tariff === 'v31' && customV2) {
      stringParams += '&p13v1PaywallBeforeAfter=true';
    }

    if (p13MixPaywallDiscountPercent && tariff === 'v31' && localStorage.getItem('p13_mix_paywall_discountPercent') === 'B') {
      stringParams += '&p13MixPaywallDiscountPercent=true';
    }

    // if (p13MixPaywallMoneyBack && customV2 && tariff === 'v31' && mix) {
    //   stringParams += '&p13MixPaywallMoneyBack=true';
    // }
  }

  if (customV2 && tariff === 'v41' && darkTheme) {
    stringParams += '&paywallMoneyBack=true';
  }

  // if (darkTheme) {
  //   stringParams += '&darkTheme=true';
  // }

  // if (p13_highPrices && tariff === 'v31') {
  //   stringParams += '&p13P2B=true';
  // }

  stringParams += '&showWeekPrice=true';
  stringParams += '&showPromoCodeBlock=true';
  if (firebase && firebase.pdf_upsale && firebase.pdf_upsale === 'pdf_upsale_on') {
    stringParams += '&PDF=true';
  }

  if (currencyInISO) {
    stringParams += '&currencyInISO=true';
  }

  if (customV2 && !tariff && !everydoggyV5) {
    stringParams += '&testChat=true';
  }

  if (firebase && firebase.ppPDFV2 && firebase.ppPDFV2 === 'ppPDFV2_b') {
    stringParams += '&ppPDFV2=true';
  }

  try {
    const country = localStorage.getItem('country_code');
    const isTariffV31 = tariff === 'v31';
    const isUsWithP13Mix = country === 'US' && p13MixP18 && !subscrUK;

    if (everydoggyV5 && isTariffV31 && mix && !isUsWithP13Mix) {
      if (params) {
        params.tariff = 'v37';
      }
    }
  } catch (e) {
    // тихо игнорируем — линк всё равно сформируется
  }

  if (p13HighPrices && config === 'customV33' && tariff === 'v31') {
    if (localStorage.getItem('p13_highPrices') === 'B') {
      params.tariff = 'v33';
      params.p13HighPrices = 'true';
    }
  }

  const p20V1 = tariff === 'v41' && !mix && customV2;
  const p20V53 = tariff === 'v41' && !mix && customV53;
  const p20V54 = tariff === 'v41' && !mix && customV54;

  const currentLang = (forceLang || window.userLang || document.documentElement.lang || window.navigator.language || '').slice(0, 2).toLowerCase();
  const isEnglishLang = currentLang === 'en';

  if (p20v1ApplePayV3MainMethod && everydoggyV5 && p20V1 && !darkTheme) {
    params.p20v1ApplePayV3MainMethod = 'true';
  }

  if ((tariff === 'v41' && !darkTheme) || tariff === 'v47' || tariff === 'v48') {
    params.p20RemoveSpecialOffe = 'true';
  }

  if (everydoggyV5 && p20V1 && !darkTheme) {
    params.p20v1LastDogTraining = 'true';
  }

  if (p20v53LastDogTraining && everydoggyV5 && p20V53 && !darkTheme) {
    params.p20v53LastDogTraining = 'true';
  }

  if (p20v54LastDogTraining && everydoggyV5 && p20V54 && !darkTheme) {
    params.p20v54LastDogTraining = 'true';
  }

  if (isHardwareEnabled && everydoggyV5 && p20V1 && !darkTheme && isEnglishLang) {
    params.hardware = 'true';
  }

  const { puppyOnboarding } = store.getState().steps;
  if (puppyOnboarding) {
    params.puppyOnboarding = 'true';
  }

  if (isRedLabelDiscountEnabled && localStorage.getItem('p20v1_paywall_redLabelDiscount_noSpecial') === 'B' && p20V1 && !darkTheme) {
    params.p20v1RedLabelDiscountNoSpecial = 'true';
  }

  const link = localStorage.getItem('link');
  if (link) {
    params.link = link;
  }

  // set all parameters to payment url
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => url.searchParams.append(key, item));
    } else {
      url.searchParams.append(key, value);
    }
  });

  return url.toString() + stringParams;
}

export default getLinkToPaymentPage;
